export const selectCabinetDashboard = (state) => state.cabinetDashboard;

export const selectAnchorDate = (state) => state.cabinetDashboard.anchorDate;
export const selectViewMode   = (state) => state.cabinetDashboard.viewMode;

export const selectDashboardStats        = (state) => state.cabinetDashboard.stats;
export const selectDashboardStatsLoading = (state) => state.cabinetDashboard.statsLoading;
export const selectDashboardStatsError   = (state) => state.cabinetDashboard.statsError;

export const selectCalendarItems         = (state) => state.cabinetDashboard.calendarItems;
export const selectCalendarLoading       = (state) => state.cabinetDashboard.calendarLoading;
export const selectCalendarError         = (state) => state.cabinetDashboard.calendarError;
